module.exports = __webpack_public_path__ + "img/caixabank-dark.6a7b72ad.png";